export default "__VITE_ASSET__CpPHkibi__"